import type { NodeOptions } from "@sentry/node";

type SentryDataCollection = NonNullable<NodeOptions["dataCollection"]>;

const USER_DERIVED_DATA_DENY_FILTER = {
  deny: ["forwarded", "-ip", "remote-", "via", "-user"],
};

/**
 * Shared privacy baseline for every Sentry runtime.
 *
 * Sentry v11 enables broader collection when this option is omitted, so keep
 * every sensitive category explicit even while the application remains on the
 * stable v10 SDK line.
 */
export const SENTRY_DATA_COLLECTION = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: USER_DERIVED_DATA_DENY_FILTER,
    response: USER_DERIVED_DATA_DENY_FILTER,
  },
  httpBodies: [],
  urlQueryParams: USER_DERIVED_DATA_DENY_FILTER,
  genAI: {
    inputs: false,
    outputs: false,
  },
  databaseQueryData: false,
  graphQL: {
    document: false,
    variables: false,
  },
  stackFrameVariables: false,
  frameContextLines: 0,
} satisfies SentryDataCollection;
